const BULK_PLAYBOOK_UPDATE_MODALS = {
  CONFIRM_UPDATE: 'CONFIRM_UPDATE',
  CONFIRM_CANCEL: 'CONFIRM_CANCEL',
};

export default BULK_PLAYBOOK_UPDATE_MODALS;
